// appetizers
import appetizers1 from './assets/appetizers/ap1.jpg'
import appetizers2 from './assets/appetizers/ap2.jpg'
import appetizers3 from './assets/appetizers/ap3.jpg'
import appetizers4 from './assets/appetizers/ap4.jpg'
import appetizers5 from './assets/appetizers/ap5.jpeg'
// beef
import beef1 from './assets/beefmenu/beef1.jpg'
import beef2 from './assets/beefmenu/beef2.jpg'
import beef3 from './assets/beefmenu/beef3.jpg'
import beef4 from './assets/beefmenu/beef4.jpg'
import beef5 from './assets/beefmenu/beef5.jpg'
import beef6 from './assets/beefmenu/beef6.jpeg'
import beef7 from './assets/beefmenu/beef7.jpg'
import beef8 from './assets/beefmenu/beef8.jpg'
import beef9 from './assets/beefmenu/beef9.jpg'
import beef10 from './assets/beefmenu/beef10.jpeg'
// chicken
import chicken1 from './assets/chickenmenu/chicken1.jpg'
import chicken2 from './assets/chickenmenu/chicken2.jpg'
import chicken3 from './assets/chickenmenu/chicken3.jpg'
import chicken4 from './assets/chickenmenu/chicken4.jpg'
import chicken5 from './assets/chickenmenu/chicken5.jpg'
import chicken6 from './assets/chickenmenu/chicken6.jpg'
import chicken7 from './assets/chickenmenu/chicken7.jpg'
import chicken8 from './assets/chickenmenu/chicken8.jpg'
import chicken9 from './assets/chickenmenu/chicken9.jpg'
import chicken10 from './assets/chickenmenu/chicken10.jpg'
// dessert
import dessert1 from './assets/dessertmenu/des1.jpg'
import dessert2 from './assets/dessertmenu/des2.jpg'
import dessert3 from './assets/dessertmenu/des3.jpg'
import dessert4 from './assets/dessertmenu/des4.jpg'
import dessert5 from './assets/dessertmenu/des5.jpg'
import dessert6 from './assets/dessertmenu/des6.jpg'
import dessert7 from './assets/dessertmenu/des7.jpg'
// extra
import extra1 from './assets/extra/ex1.jpg'
import extra2 from './assets/extra/ex2.jpg'
import extra3 from './assets/extra/ex3.jpg'
import extra4 from './assets/extra/ex4.jpg'
import extra5 from './assets/extra/ex5.jpg'
// juice
import juice1 from './assets/juicemenu/ju1.jpg'
import juice2 from './assets/juicemenu/ju2.jpg'
import juice3 from './assets/juicemenu/ju3.png'
import juice4 from './assets/juicemenu/ju4.jpg'
import juice5 from './assets/juicemenu/ju5.jpg'
import juice6 from './assets/juicemenu/ju6.jpg'
import juice7 from './assets/juicemenu/ju7.jpg'




// Lucia Best Burger Menu Images
import LuciaBestBurger1 from './assets/burger/1.png'
import LuciaBestBurger2 from './assets/burger/2.png'
import LuciaBestBurger3 from './assets/burger/3.png'
import LuciaBestBurger4 from './assets/burger/4.png'
import LuciaBestBurger5 from './assets/burger/5.png'
import LuciaBestBurger6 from './assets/burger/6.png'
import LuciaBestBurger7 from './assets/burger/7.png'
import LuciaBestBurger8 from './assets/burger/8.png'




// Testmonial Images
import Testmonial1 from './assets/testmonial/1.png'
import Testmonial2 from './assets/testmonial/2.png'
import Testmonial3 from './assets/testmonial/3.png'

// Restaurant Image from About Page 
import Src1 from './assets/carsualSlide/res7.jpg'
import Src2 from './assets/carsualSlide/res6.png'
import Src3 from './assets/carsualSlide/res5.jpg'



// Data Main Menu
export const dataMainMenu = [
    {
        sys:{
            id:1,
            name: 'appetizers'
        },
        items: [{
            type: 'onion rings',
            image: appetizers1,
            salary: "18$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'mozarella sticks',
            image: appetizers2,
            salary: "29$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chessy fries',
            image: appetizers3,
            salary: "24$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chicken fries',
            image: appetizers4,
            salary: "32$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chicken wings',
            image: appetizers5,
            salary: "34$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        }]
    },
    {
        sys: {
            id: 2,
            name: 'beef'
        },
        items: [{
            type: 'beefrachy',
            image: beef1,
            salary: "44$",
            components: "beef+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'beefturkish',
            image: beef2,
            salary: "46$",
            components: "beef+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'beefhanabillo',
            image: beef3,
            salary: "54$",
            components: "beef+barbecue sause+onion sause + tomato + ranch sause+cucumber"
        },
        {
            type: 'beefrap',
            image: beef4,
            salary: "37$",
            components: "beef+barbecue sause+mexico sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'beefkrac',
            image: beef5,
            salary: "39$",
            components: "beef+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'beeftower',
            image: beef6,
            salary: "41$",
            components: "beef+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'beefmexician',
            image: beef7,
            salary: "52$",
            components: "beef+barbecue sause+onion sause + tomato + ranch sause+cucumber"
        },
        {
            type: 'beefhunyyomy',
            image: beef8,
            salary: "63$",
            components: "beef+mexico sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'beefsuper',
            image: beef9,
            salary: "50$",
            components: "beef+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'bigbeef',
            image: beef10,
            salary: "43$",
            components: "beef+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        }]
    },
    {
        sys:{
            id: 3,
            name: 'chicken'
        },
        items: [{
            type: 'chickenrachy',
            image: chicken1,
            salary: "44$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chickenturkish',
            image: chicken2,
            salary: "46$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chickenhanabillo',
            image: chicken3,
            salary: "54$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chickenrap',
            image: chicken4,
            salary: "37$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chickenkrac',
            image: chicken5,
            salary: "39$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chickenftower',
            image: chicken6,
            salary: "41$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chickenmexician',
            image: chicken7,
            salary: "52$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chickenhunyyomy',
            image: chicken8,
            salary: "63$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chickensuper',
            image: chicken9,
            salary: "50$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'bigchicken',
            image: chicken10,
            salary: "43$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        }]
    },
    {
        sys:{
            id: 4,
            name: 'dessert'
        },
        items: [{
            type: 'molten cake',
            image: dessert1,
            salary: "44$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'wavel nutella',
            image: dessert2,
            salary: "46$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'cheese cake',
            image: dessert3,
            salary: "54$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'red filfet',
            image: dessert4,
            salary: "37$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'black forest',
            image: dessert5,
            salary: "39$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'choclate cake',
            image: dessert6,
            salary: "41$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'caramel cake',
            image: dessert7,
            salary: "52$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        }]
    },
    {
        sys:{
            id: 5,
            name: 'extra'
        },
        items: [{
            type: 'coleslaw',
            image: extra1,
            salary: "10$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'katchub sause',
            image: extra2,
            salary: "10$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chesse sause',
            image: extra3,
            salary: "10$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'ranch sause',
            image: extra4,
            salary: "10$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'barbecue sause',
            image: extra5,
            salary: "10$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        }]
    },
    {
        sys:{
            id: 6,
            name: 'juices'
        },
        items: [{
            type: 'mango',
            image: juice1,
            salary: "12$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'banana',
            image: juice2,
            salary: "10$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'watermelon',
            image: juice3,
            salary: "14$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'cantalope',
            image: juice4,
            salary: "13$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'chocolate',
            image: juice5,
            salary: "18$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'strawberry',
            image: juice6,
            salary: "17$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        },
        {
            type: 'orange',
            image: juice7,
            salary: "8$",
            components: "chicken+barbecue sause+onion sause + tomato + catchub sause+cucumber"
        }]
    }
]


// Lucia Best Burger Menu Info
const style = ['col-xl-6 col-md-6 col-lg-6', 'col-md-6 col-lg-6', 'col-lg-6 col-md-6']
export const dataLuciaMenu = [
    {
        image: LuciaBestBurger1,
        title: 'Beefy Burgers',
        subTitle: 'Great way to make your business appear trust and relevant.',
        salary: 5,
        style: style[0]
    },
    {
        image: LuciaBestBurger2,
        title: 'Burger Boys',
        subTitle: 'Great way to make your business appear trust and relevant.',
        salary: 5,
        style: style[1]
    },
    {
        image: LuciaBestBurger3,
        title: 'Burger Bizz',
        subTitle: 'Great way to make your business appear trust and relevant.',
        salary: 5,
        style: style[2]
    },
    {
        image: LuciaBestBurger4,
        title: 'Crackles Burger',
        subTitle: 'Great way to make your business appear trust and relevant.',
        salary: 5,
        style: style[0]
    },
    {
        image: LuciaBestBurger5,
        title: 'Bull Burgers',
        subTitle: 'Great way to make your business appear trust and relevant.',
        salary: 5,
        style: style[2]
    },
    {
        image: LuciaBestBurger6,
        title: 'Rocket Burger',
        subTitle: 'Great way to make your business appear trust and relevant.',
        salary: 5,
        style: style[2]
    },
    {
        image: LuciaBestBurger7,
        title: 'Smokin Burger',
        subTitle: 'Great way to make your business appear trust and relevant.',
        salary: 5,
        style: style[2]
    },
    {
        image: LuciaBestBurger8,
        title: 'Delish Burger',
        subTitle: 'Great way to make your business appear trust and relevant.',
        salary: 5,
        style: style[2]
    },
    {
        image: LuciaBestBurger4,
        title: 'Crackles Burger',
        subTitle: 'Great way to make your business appear trust and relevant.',
        salary: 5,
        style: style[0]
    },
    {
        image: LuciaBestBurger5,
        title: 'Bull Burger',
        subTitle: 'Great way to make your business appear trust and relevant.',
        salary: 5,
        style: style[2]
    }
]


export const dataTestimonial = [
    {
        info: '“Donec imperdiet congue orci consequat mattis. Donec rutrum porttitor sollicitudin.Pellentesque id dolor tempor sapien feugiat ultrices nec sed neque.',
        image: Testmonial1,
        name: 'Kristiana Chouhan'
    },
    {
        info: '“Donec imperdiet congue orci consequat mattis. Donec rutrum porttitor sollicitudin.Pellentesque id dolor tempor sapien feugiat ultrices nec sed neque.',
        image: Testmonial2,
        name: 'Arafath Hossain'
    },
    {
        info: '“Donec imperdiet congue orci consequat mattis. Donec rutrum porttitor sollicitudin.Pellentesque id dolor tempor sapien feugiat ultrices nec sed neque.',
        image: Testmonial3,
        name: 'A.H Shemanto'
    }
]


// Restaurent data from About Page 
export const restaurantImages = [
    {
        image: Src1,
        info: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam numquam quisquam ipsa fuga asperiores! Blanditiis, veritatis cumque? Expedita quidem accusamus iste et rem asperiores! Mollitia perspiciatis pariatur rem blanditiis rerum cum voluptatem earum fugiat possimus, soluta aliquid! Optio sunt consequatur nisi nam corporis iure, ab nobis aliquam, placeat in maxime ad maiores dolorum vel repudiandae consectetur, tempore aspernatur? Quasi qui, praesentium ea quia facilis maiores dolor. Eligendi, blanditiis eum. Sit?'
    },
    {
        image: Src2,
        info: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempore sed sapiente ut voluptatum doloremque quis voluptatibus. Natus nemo est autem enim repellat. Voluptatibus illum consectetur repudiandae cumque commodi fugiat ducimus amet consequuntur perferendis, dolores autem quaerat sequi ex debitis porro distinctio culpa laudantium, placeat a voluptates eius unde, reprehenderit quo non. Autem sed, facilis a quaerat voluptate officiis ab est debitis corrupti? Animi accusamus provident quasi sed pariatur, eveniet nemo.'
    },
    {
        image: Src3,
        info: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi, esse sint ipsa debitis voluptas doloremque iusto quo ab quis quidem consequatur quisquam! Aliquid necessitatibus omnis neque architecto ea hic voluptates atque veniam commodi dolor consequatur in ipsum eveniet totam nam maiores fugit possimus nemo deleniti dignissimos, iusto ad libero vero! Nesciunt eveniet odit accusantium tempora quae deleniti, aperiam quam fuga dolor consequatur velit quia eius officia exercitationem aliquam quaerat voluptatum!'
    }
]